import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import { SentryErrorBoundary } from '@/components/SentryErrorBoundary'

// Pages
import NotFoundPage from '@/pages/NotFound'
import CheckoutPage from '@/pages/Checkout'
import SuccessPage from '@/pages/Success'
import ProcessingPage from '@/pages/Processing'
import ErrorPage from '@/pages/Error'

function App() {
  return (
    <SentryErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/:templateSlug" element={<CheckoutPage />} />
          <Route path="/success/:orderId" element={<SuccessPage />} />
          <Route path="/processing/:orderId" element={<ProcessingPage />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </SentryErrorBoundary>
  )
}

export default App
